import { GetPropertiesType } from "./types";

export class Schema<T extends GetPropertiesType<T>> {
  readonly properties: T;

  constructor(properties: T) {
    this.properties = properties;
  }
}
